<!-- <div id="countdown" [style.width] ="size+'px'" [style.height] ="size+'px'">
    <svg id="counter" [style.width] ="size+'px'" [style.height] ="size+'px'">
        <circle id="base" [attr.r]="radius" [attr.cx] ="size/2" [attr.cy] ="size/2" [style.strokeDasharray]="strokeDashArray" [style.strokeDashoffset]="0"></circle>
        <circle id="over" [class.orange]="firstThreshold" [class.red]="secondThreshold" [class.animated]="animated" [attr.r]="radius" [attr.cx] ="size/2" [attr.cy] ="size/2" [style.strokeDasharray]="strokeDashArray" [style.strokeDashoffset]="strokeDashOffset" ></circle>
    </svg>
    <div id="count" [style.lineHeight] ="size+'px'">{{formatTime(remaining)}}</div>
</div> -->

<div class="count">{{ remaining() ||  secondsTemp() }}</div>
